import {
    actionCreator,
    checkHttpStatus, 
    jsonApiHeader, 
    showErrorMessage, 
    showSuccessMessage, 
    manageAppointmentsActionTypes, 
    createSearchUrlForCustomAPI,
    GET_PATIENT_APPOINTMENT_LIST_FOR_AGENCY, 
    GET_PATIENT_APPOINTMENT_LIST_FOR_SIGNATUREONLY_FOR_AGENCY,
    POST_BATCHENCOUNTERGUARDIANSIGNATURES, 
    POST_BATCHENCOUNTERGUARDIANSIGNATURESANDCOMPLETE,
} from '../constants/ApiConstants';

export const getAppointmentList = (searchObj) => {
    return (dispatch, getState) => {
        dispatch(actionCreator(manageAppointmentsActionTypes.get_patient_appointment_list.REQUEST));
        let query_params = createSearchUrlForCustomAPI(searchObj);
        fetch(`${GET_PATIENT_APPOINTMENT_LIST_FOR_AGENCY}${query_params}`, {
            method: 'get',
            headers: jsonApiHeader(getState().login.access_token, 'application/json'),
        })
            .then(checkHttpStatus)
            .then(function (response) {
                if (response.statusCode >= 200 && response.statusCode < 300 && response.statusCode !== 204) {
                    dispatch(actionCreator(manageAppointmentsActionTypes.get_patient_appointment_list.SUCCESS, response));
                } else {
                    dispatch(actionCreator(manageAppointmentsActionTypes.get_patient_appointment_list.SUCCESS, null));
                }
            }).catch(function (error) {
                console.log('error get_patient_appointment_list', error);
            });
    };
};

export const getAppointmentListForSignatureOnly = (searchObj) => {
    return (dispatch, getState) => {
        dispatch(actionCreator(manageAppointmentsActionTypes.get_patient_appointment_list.REQUEST));
        let query_params = createSearchUrlForCustomAPI(searchObj);
        fetch(`${GET_PATIENT_APPOINTMENT_LIST_FOR_SIGNATUREONLY_FOR_AGENCY}${query_params}`, {
            method: 'get',
            headers: jsonApiHeader(getState().login.access_token, 'application/json'),
        })
            .then(checkHttpStatus)
            .then(function (response) {
                if (response.statusCode >= 200 && response.statusCode < 300 && response.statusCode !== 204) {
                    dispatch(actionCreator(manageAppointmentsActionTypes.get_patient_appointment_list.SUCCESS, response));
                } else {
                    dispatch(actionCreator(manageAppointmentsActionTypes.get_patient_appointment_list.SUCCESS, null));
                }
            }).catch(function (error) {
                console.log('error get_patient_appointment_list', error);
            });
    };
};

export const saveEncounterWithSignature = (formProps) => {
    return (dispatch, getState) => {
        dispatch(actionCreator(manageAppointmentsActionTypes.post_saveBatchEncounterGuardianSignatures.REQUEST));
        fetch(`${POST_BATCHENCOUNTERGUARDIANSIGNATURES}`, {
            method: 'POST',
            headers: jsonApiHeader(getState().login.access_token, 'application/json'),
            body: JSON.stringify(formProps),
        })
            .then(checkHttpStatus)
            .then(function (response) {
                if (response.statusCode >= 200 && response.statusCode < 300 && response.statusCode !== 204) {
                    showSuccessMessage(response.message);
                    dispatch(actionCreator(manageAppointmentsActionTypes.post_saveBatchEncounterGuardianSignatures.SUCCESS, response));
                } else {
                    showErrorMessage(response.message);
                    dispatch(actionCreator(manageAppointmentsActionTypes.post_saveBatchEncounterGuardianSignatures.SUCCESS, null));
                }
            })
            .catch(function (error) {
                console.log('error post_saveBatchEncounterGuardianSignatures', error);
            });
    };
};

export const saveEncounterWithSignatureAndComplete = (formProps) => {
    return (dispatch, getState) => {
        dispatch(actionCreator(manageAppointmentsActionTypes.post_saveBatchEncounterGuardianSignaturesAndComplete.REQUEST));
        fetch(`${POST_BATCHENCOUNTERGUARDIANSIGNATURESANDCOMPLETE}`, {
            method: 'POST',
            headers: jsonApiHeader(getState().login.access_token, 'application/json'),
            body: JSON.stringify(formProps),
        })
            .then(checkHttpStatus)
            .then(function (response) {
                if (response.statusCode >= 200 && response.statusCode < 300 && response.statusCode !== 204) {
                    showSuccessMessage(response.message);
                    dispatch(actionCreator(manageAppointmentsActionTypes.post_saveBatchEncounterGuardianSignaturesAndComplete.SUCCESS, response));
                } else {
                    showErrorMessage(response.message);
                    dispatch(actionCreator(manageAppointmentsActionTypes.post_saveBatchEncounterGuardianSignaturesAndComplete.SUCCESS, null));
                }
            })
            .catch(function (error) {
                console.log('error post_saveBatchEncounterGuardianSignaturesAndComplete', error);
            });
    };
};




// WEBPACK FOOTER //
// ./src/modules/PatientPortal/containers/ManageAppointments/components/appointments/actions/index.js